import { RatingButton, RatingColour, RatingImage } from 'components/buttons/rating-button';
import React from 'react';

interface IHappinessRatingProps {
  rating: number;
  onChange: (rating: number) => void;
}

export const HappinessRating: React.FC<IHappinessRatingProps> = ({ rating, onChange }) => {
  return (
    <div
      style={{
        display: 'flex',
        gap: '5px',
      }}
    >
      {[1, 2, 3, 4, 5].map(value => {
        const r = ratings[value];
        return (
          <RatingButton
            key={value}
            image={r.image}
            selected={rating === value}
            onClick={() => onChange(value)}
          >
            {r.message.map((x, i) => (
              <React.Fragment key={i}>
                {i !== 0 && <br />}
                {x}
              </React.Fragment>
            ))}
          </RatingButton>
        );
      })}
    </div>
  );
};

export const HappinessRatingValue: React.FC<{ value: number; hideText?: boolean }> = ({
  value,
  hideText,
}) => {
  const rating = ratings[value];
  if (!rating) return null;
  return (
    <>
      <RatingImage image={rating.image} />
      {!hideText && rating.message.join(' ')}
    </>
  );
};

interface IRating {
  message: string[];
  image: RatingColour;
}

const ratings: Record<number, IRating> = {
  1: {
    message: ['Much too', 'easy'],
    image: 'red',
  },
  2: {
    message: ['A little', 'easy'],
    image: 'amber',
  },
  3: {
    message: ['About', 'right'],
    image: 'green',
  },
  4: {
    message: ['A little', 'difficult'],
    image: 'amber',
  },
  5: {
    message: ['Much too', 'difficult'],
    image: 'red',
  },
};
